import { RepaymentSection } from 'modules/cm/pages/CaseDetailsPage/subPages/RepaymentStrategy/RepaymentSection';
import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import { isLoading } from '../store/selectors';

const state = (state: RootState) => {
  return {
    isLoading: isLoading(state),
  };
};
const dispatchers = {};

export default connect(state, dispatchers)(RepaymentSection);
